<template>
    <div id="rms-login" class="apply-bootstrap">
        <div class="container">
            <div class="row" id="rms-login-form">
                <div id="rmsLogo">
                    <img alt="RMS Login Page" src="../../rms/xsl/images/rmsLogo.png">
                </div>
                <div class="rms-login-centered">
                    <h1>Recruiter Management System</h1>
                    <layout-container c-id="layoutContainer_RMS_Login"></layout-container>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import "@common/syncfusionCss";
import { library } from "@common/library/library";
import { uStore } from "@common/userStore";

const rmsLoginCmp = {
    components: {
        layoutContainer: defineAsyncComponent(() => import('@common/layoutContainer/layoutContainer.vue')),
        loginForm: defineAsyncComponent(() => import('@common/loginForm/loginForm.vue'))
    },
    methods: {
        processAction: async function (act) {
            switch (act) {
                case 'login':
                    if (library.isFromLocalhost()) {
                        let localSid = library.getCookie('sds_localSid');
                        let loggedUser = await uStore().getLoggedUsers(['rms']);
                        if (localSid) {
                            location.href = PROJECTS_URL + 'rms/index.php?localhostDIS=' + localSid + '&localhostClientID=' + loggedUser;
                            return;
                        }
                        uStore().logout('rms');
                        return;
                    }
                    location.href = '../rms/index.php';
                    location.reload();
                    break;
            }
        },
    }
};

export default rmsLoginCmp;
</script>

<style lang="css">

body {
    background-color:#FFFFFF;
    margin:0
}

.rms-login-centered {
    text-align: center;
}

#rms-login h1 {
    color:#005C8F;
    font-family:Arial;
    font-size:16pt;
    font-weight: bold;
}

#rmsLogo {
    width: 100%;
    margin-left: -30px;
}

#rms-login #LoginPanel {
    background-color: #FFFFFF !important;
    border-width: 0px !important;
    padding-top: 0px !important;
}

#rms-login .sso-client {
    background-color: #FFFFFF !important;
    border-width: 0px !important;
}

#rms-login label {
    font-size: 14px !important;
    color: #888888;
    font-weight: 500;
}

#rms-login button, #rms-login input, #rms-login select, #rms-login textarea {
    background-color: transparent;
    border-style: none;
}

#rms-login .e-control-wrapper {
    border-bottom-width: 1px;
    border-bottom-color: #D4D4D4;
}

#rms-login .e-input {
    border-bottom-width: 0px;
    padding: 3px 5px;
}

#rms-login .privacy-policy {
    font-size: 7pt;
    font-weight: bold;
    padding-top: 20px;
}

#rms-login .require-indicator {
    display: none;
}

#rms-login .login-form-login {
    padding-top: 20px;
}

#rms-login .login-form-login > div {
    display: inline !important;
    justify-content: center !important;
}

#rms-login button {
    color: #FFF !important;
    background: #005C8F !important;
    width: 100%;
    font-size: 14px;
    text-transform: capitalize;
}

#rms-login #GooglePanel {
    background-color: #FFFFFF;
    border-bottom-color: #D4D4D4;
    border-width: 1px 0px 1px 0px;
    border-bottom-style: solid;
    padding: 20px 0px 20px 0px;
    margin-top: -20px;
    margin-left: 20px;
    margin-right: 20px;
}

#rms-login .custom-message-container {
    width: 100%;
}

#rms-login-form {
    width: 350px;
    max-width: 90%;
    margin: 0 auto;
}

</style>
